import { pgTable, text, uuid, date, foreignKey } from 'drizzle-orm/pg-core';
import { orgTableBase, orgPrimaryKey } from './org-id';
import { PhaseType } from '../enums';
import { Team } from '../schema';
import { relations } from 'drizzle-orm';
export const Phase = pgTable('phase', {
    ...orgTableBase,
    name: text('name').notNull(),
    type: PhaseType('type'),
    color: text('color').notNull(),
    startDate: date('start_date', { mode: 'string' }).notNull(),
    endDate: date('end_date', { mode: 'string' }).notNull(),
    teamId: uuid('team_id').notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    teamFk: foreignKey({
        columns: [table.orgId, table.teamId],
        foreignColumns: [Team.orgId, Team.id],
    }),
}));
export const Phase_Relations = relations(Phase, ({ one }) => ({
    team: one(Team, {
        fields: [Phase.orgId, Phase.teamId],
        references: [Team.orgId, Team.id],
    }),
}));
//# sourceMappingURL=phase.js.map